import { Button } from '@givebutter/primitives/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUpdateWorkflowStatus } from 'assets/js/pages/engage/workflows/hooks/useUpdateWorkflowStatus';
import { getNextStatusData } from 'assets/js/pages/engage/workflows/utils/helpers';
import {
    nodeFormErrorsSelector,
    useReactFlowStore,
    workflowHasActionSelector,
} from 'assets/js/pages/engage/workflows/utils/store';
import * as Tooltip from 'components/tooltip';
import { useCurrentWorkflow } from 'customHooks/useCurrentWorkflow';

const UpdateStatusButton = () => {
    const { data: workflow } = useCurrentWorkflow();
    const { mutate: updateStatus, isPending } = useUpdateWorkflowStatus();

    const workflowHasAction = useReactFlowStore(workflowHasActionSelector);
    const { errorCount } = useReactFlowStore(nodeFormErrorsSelector);

    const { buttonText, nextStatus, icon } = getNextStatusData(workflow.status);
    const buttonVariant = nextStatus === 'active' ? 'solid' : 'outline';
    const buttonColor = nextStatus === 'active' ? 'primary' : 'neutral';

    return workflowHasAction && errorCount === 0 ? (
        <Button
            variant={buttonVariant}
            color={buttonColor}
            size="sm"
            disabled={isPending}
            onClick={() => {
                updateStatus({ workflowId: workflow.id, status: nextStatus });
            }}
        >
            <FontAwesomeIcon icon={icon} size="lg" />
            {buttonText}
        </Button>
    ) : (
        <Tooltip.Root>
            <Tooltip.Trigger asChild>
                <Button variant={buttonVariant} color={buttonColor} size="sm" disabled>
                    <FontAwesomeIcon icon={icon} size="lg" />
                    {buttonText}
                </Button>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <Tooltip.Arrow inverse />
                    <p className="max-w-48 text-sm">
                        Edit your workflow to resolve errors before publishing
                    </p>
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { getNextStatusData, UpdateStatusButton };
